import Box from '@mui/material/Box';
import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import { SxProps } from '@mui/system';
import { FC, useContext } from 'react';
import { ActiveTabContext } from '.';

type TabPanelProps = {
  index: number;
  className?: string;
  sx?: SxProps<ThemeMui5>;
};

const TabPanel: FC<TabPanelProps> = ({
  index,
  children,
  className,
  sx = {},
  ...restTabPanelProps
}): JSX.Element => {
  const { activeTab } = useContext(ActiveTabContext);
  return (
    <Box
      mt={2}
      sx={sx}
      role='tabpanel'
      hidden={activeTab !== index}
      className={className}
      {...restTabPanelProps}
    >
      {activeTab === index && children}
    </Box>
  );
};

export default TabPanel;
